<template>
  <div>
    <div v-if="(GET_PRODUTOS_COTACAO_PEDIDO.length > 0)">
      <sys-data-table
        v-model="PRODUTOS_SELECIONADOS_COTACAO_PEDIDO_COMPUTED"
        :headers="headers"
        :items="GET_PRODUTOS_COTACAO_PEDIDO"
        :height="alturaDaJanela - 225"
        :item-height="45"
        show-select
        :search="pesquisar"
        item-key="idproduto"
        class="font-resp-tabela table-full-screen elevation-1"
      >
        <template #top>
          <div class="d-flex align-center pt-3 pb-2 pl-1">
            <v-icon>mdi-format-list-bulleted</v-icon>
            <span class="ml-1 font-18 font-weight-medium">Produtos a Comprar</span>

            <v-divider vertical class="ml-4" />

            <div class="d-flex align-center h-20px ml-5">
              <AtualizarMultiplosItensCarrinho />

              <DeletarMultiplosItensCotacaoPedido class="ml-5" />
            </div>
          </div>

          <v-spacer />

          <v-text-field
            v-model="pesquisar"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            class="ma-0 mr-2"
            style="max-width: 450px"
          />
        </template>

        <template #item.sugerido="{ value }">
          {{ Helpers.formatarValorComCasas(value, 2) }}
        </template>

        <template #item.cobertura_estoque_futura="{item}">
          <CalculaCoberturaEstoqueFutura :item="{...item, sugestao: item.quantidade}" />
        </template>

        <template #item.preco_custo_base="{ value }">
          R$ {{ Helpers.formatarValorComCasas(value, 2) }}
        </template>

        <template #item.quantidade="{ item }">
          <div
            v-if="!item.pedido_compra_fracionada_id"
            class="text-cente display-flex"
          >
            <sysInputFormatador
              v-model="item.quantidade"
              :maxDigitos="QTDE_DECIMAIS"
              :removerValorIrrelevante="true"
              centralizar
              class="input-regular w-100 font-resp txt-table-prod"
              :style="{
                'border-bottom-color: red' : verificaLoteEstoqueMinimo({ ...item, qtde_pedido: item.quantidade, preco_custo: item.preco })
              }"
              @blur="validarQuantidadeCompra({ ...item, qtde_pedido: item.quantidade, preco_custo: item.preco })"
              @focus="$event.target.select()"
              @keyup.enter="$event.target.blur();"
              @change="item.exportado = 'N'"
            />

            <valida-lote-minimo
              v-if="!verificaSeMultiploDeLoteMinimo({ ...item, qtde_pedido: item.quantidade, preco_custo: item.preco }, pedido_selecionado) || item.quantidade === 0"
              :ref="`loteMinimo-${pedido_selecionado.idpedido}-cotacao-${item.idproduto}-ref`"
              v-model.number="item.quantidade"
              :lote-minimo="parseFloat(item.lote_minimo)"
              @change="validarQuantidadeCompra({ ...item, qtde_pedido: item.quantidade, preco_custo: item.preco })"
            />

            <SugestaoEstoqueEstetico
              v-else-if="!verificaSeSurgestaoEstoqueMinimo({ ...item, qtde_pedido: item.quantidade, preco_custo: item.preco }, pedido_selecionado)"
              :ref="`estoqueEstetico-${pedido_selecionado.idpedido}-cotacao-${item.idproduto}-ref`"
              v-model.number="item.quantidade"
              :estoque_minimo="item.estoque_minimo"
              :estoque="item.estoque"
              :estoque_transito="item.estoque_transito"
              @change="validarQuantidadeCompra({ ...item, qtde_pedido: item.quantidade, preco_custo: item.preco }, false)"
            />
          </div>

          <div v-else class="text-center">
            {{ Helpers.formatarValor(item.quantidade) }}
          </div>
        </template>

        <template #item.preco="{ item }">
          <TextFieldFormatadorDeValor
            v-model="item.preco"
            dense
            class="text-field-centralizado font-12 w-100"
            hide-details
            prefix="R$"
            :maxDigitos="2"
            @blur="atualizarQuantidadePrecoCotacao(item)"
            @keyup.enter="$event.target.blur();"
            @focus="$event.target.select()"
          />
        </template>

        <template v-slot:item.indicador="{ item }">
          <div class="indicador">
            <v-icon v-if="custoVsBase(item) > 0" color="red" small>
              mdi-arrow-up
            </v-icon>
            <v-icon v-else-if="custoVsBase(item) < 0" color="green" small>
              mdi-arrow-down
            </v-icon>
            <v-icon v-else class="ml-7">mdi-arrow-left-right</v-icon>
            <v-chip v-show="custoVsBase(item) != 0" small>
              <span style="font-size: 9pt">
                {{
                  Math.abs(custoVsBase(item)) < 999
                    ? Helpers.formatarValor(Math.abs(custoVsBase(item)))
                    : "999+"
                }}
              </span>
            </v-chip>
          </div>
        </template>

        <template #item.total="{ value }">
          {{ Helpers.formatarValorComCasas(value, 2) }}
        </template>

        <template #item.action="{ item }">
          <div class="d-flex align-center">
            <AtualizarItemCarrinho :item="item"/>
            <DeletarItemCotacaoPedido :item="item" />
          </div>
        </template>
      </sys-data-table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { atualizarQuantidadePrecoCotacao } from "./CotacaoApi";
import mixinCompra from "@/components/compra/MixinCompra";
import Responsividade from '@/helpers/ResponsiveHeight';
import DeletarItemCotacaoPedido from './Deletes/DeletarItemCotacaoPedido.vue';
import TextFieldFormatadorDeValor from '@/components/utils/TextFieldFormatadorDeValor.vue';
import sysInputFormatador from "@/components/utils/InputFormatadorDeValor";
import ValidaLoteMinimo from '@/components/compra/ValidaLoteMinimo.vue';
import SugestaoEstoqueEstetico from '@/components/compra/SugestaoEstoqueEstetico.vue';
import DeletarMultiplosItensCotacaoPedido from './Deletes/DeletarMultiplosItensCotacaoPedido.vue';
import CalculaCoberturaEstoqueFutura from '@/components/compra/CalculaCoberturaEstoqueFutura.vue';
import AtualizarItemCarrinho from './AtualizarCarrinho/AtualizarItemCarrinho.vue';
import AtualizarMultiplosItensCarrinho from './AtualizarCarrinho/AtualizarMultiplosItensCarrinho.vue';

export default {
  mixins: [mixinCompra, Responsividade],
  props: {
    pedido_selecionado: {
      type: Object
    }
  },
  components: {
    TextFieldFormatadorDeValor,
    DeletarItemCotacaoPedido,
    ValidaLoteMinimo,
    SugestaoEstoqueEstetico,
    sysInputFormatador,
    CalculaCoberturaEstoqueFutura,
    DeletarMultiplosItensCotacaoPedido,
    AtualizarItemCarrinho,
    AtualizarMultiplosItensCarrinho
},
  data() {
    return {
      pesquisar: '',
      headers: [
        { text: "#", value: "item", width: "2%" },
        { text: 'Fornecedor', value: 'razao_social' },
        { text: "ID Produto", value: "idproduto" },
        { text: "Cód. Fabricante", value: "cod_produto" },
        { text: "Descrição Produto", value: "descricao_produto" },
        { text: "Última Compra", value: "data_ultima_requisicao" },
        { text: "UND", value: "unidade_compra", width: "2%" },
        { text: "Sugerido", class: 'text-start', value: "sugerido", width: "4%", align: 'center' },
        { text: "", value: "icon_motivos", sortable: false, width: "1%" },
        { text: "Quantidade", value: "quantidade", sortable: false, align: "center", width: "4%" },
        { text: "Cobertura Estoque Futura (dias)", class: 'text-start', value: "cobertura_estoque_futura", sortable: false, align: "center", width: "8%" },
        { text: "Último Preço (R$)", value: "preco_custo_base", class: 'text-start', width: "6%", align: "center" },
        { text: "Preço Atual (R$)", value: "preco", align: "center", width: "7%" },
        { text: "Indicador (%)", class: 'text-start', value: "indicador", align: "center", width: "5%" },
        { text: "Preço Total (R$)", class: 'text-start', value: "total", width: "7%", align: "center" },
        { text: "", value: "action", sortable: false, align: "center", width: "50px" },
      ],
    }
  },
  computed: {
    ...mapGetters({
      configuracoes: "configuracoes/carrinho",
      getProdutosSelecionadosCarrinho: "CotacaoCarrinhoCompra/GET_PRODUTOS_SELECIONADOS_CARRINHO",
      GET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO: "CotacaoCarrinhoCompra/GET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO",
      GET_PRODUTOS_COTACAO_PEDIDO: "CotacaoCarrinhoCompra/GET_PRODUTOS_COTACAO_PEDIDO"
    }),
    QTDE_DECIMAIS() {
      return this.configuracoes.CASAS_DECIMAIS_CARRINHO;
    },
    PRODUTOS_SELECIONADOS_COTACAO_PEDIDO_COMPUTED: {
      get() {
        return this.GET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO;
      },
      set(valor) {
        this.SET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO(valor);
      }
    }
  },
  methods: {
    ...mapMutations({
      SET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO: "CotacaoCarrinhoCompra/SET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO",
      SET_COTACOES_ID_PEDIDO: "CotacaoCarrinhoCompra/SET_COTACOES_ID_PEDIDO",
      SET_PRODUTOS_COTACAO_PEDIDO: "CotacaoCarrinhoCompra/SET_PRODUTOS_COTACAO_PEDIDO"
    }),
    verificaLoteEstoqueMinimo (item) {
      return !this.verificaSeMultiploDeLoteMinimo(item) && !this.verificaSeSurgestaoEstoqueMinimo(item, this.pedido_selecionado);
    },
    validarQuantidadeCompra(produto, validar_estoque_minimo = true) {
      this.$nextTick(() => {
        if (!this.verificaSeMultiploDeLoteMinimo(produto) || produto.qtde_pedido === 0) {
          this.ativarAlertaLoteMinimoProduto(produto);
          return;
        }

        if (validar_estoque_minimo && !this.verificaSeSurgestaoEstoqueMinimo(produto, this.pedido_selecionado)) {
          this.ativarAlertaEstoqueEsteticoProduto(produto);
          return;
        }

        this.atualizarQuantidadePrecoCotacao(produto);
      })
    },
    ativarAlertaLoteMinimoProduto(produto) {
      const loteMinimoRef = `loteMinimo-${this.pedido_selecionado.idpedido}-cotacao-${produto.idproduto}-ref`;

      if (this.$refs[loteMinimoRef]) this.$refs[loteMinimoRef].ativador_menu = true;
    },
    ativarAlertaEstoqueEsteticoProduto(produto) {
      const estoqueExteticoRef = `estoqueEstetico-${this.pedido_selecionado.idpedido}-cotacao-${produto.idproduto}-ref`;

      setTimeout(() => { if (this.$refs[estoqueExteticoRef]) this.$refs[estoqueExteticoRef].ativador_menu = true; }, 300);
    },
    custoVsBase(i) {
      const custo = parseFloat(i.preco);
      const custoBase = parseFloat(i.preco_custo_base);

      const precoCustoValido = custo > 0 ? custo : 0;

      let percentual;

      if (i.preco_custo_base > 0) {
        percentual = ((precoCustoValido / custoBase - 1) * 100).toFixed(2);
      } else {
        percentual = 0;
      }

      return percentual;
    },
    atualizarQuantidadePrecoCotacao(item) {
      this.$store.dispatch(
        "loading/addRequisicao",
        atualizarQuantidadePrecoCotacao(item)
          .then((c) => {
            this.SET_COTACOES_ID_PEDIDO(c.ids);
            this.SET_PRODUTOS_COTACAO_PEDIDO(c.produtos);
          })
          .catch(() => this.Helpers.logout())
      )
    }
  }
}
</script>

<style scoped>

.indicador {
  display: flex;
  font-size: 10px;
  margin-right: 5px;
}

</style>
